import React, { useContext } from 'react';
import '../../css/interval.css';
import { functionContext } from '../../App'

function Interval() {

  const { startInterval, endInterval, setintervalTime } = useContext(functionContext);

  return (
    <>
      <div id="interval">
      <input
        onChange={(e)=> setintervalTime(Number(e.currentTarget.value) * 1000)}
        className="interval-input"
        type="number"
        min="0"
        step="0.5"
        defaultValue="5"
      />
      <button onClick={() => startInterval()} className="start-interval-button">Start interval</button>
      <button onClick={() => endInterval()} className="end-interval-button">End interval</button>
      </div>
    </>
  )
}

export default Interval;
